<template>
  <div class="minW1060-auto minH600 bg-fff mag10">
    home
  </div>
</template>

<script>
  export default {
    name: 'Home'
  }
</script>

<style scoped>

</style>
